import classNames from 'classnames';
import React from 'react';
import {geShopIconConvertor} from '../../../../utilities/helper/shopIconConvertor';
import styles from '../../footer.module.scss';
import {useAuth} from '../../../../context/authContext';

interface IconSwitcherProps {
  isMain?: boolean;
  isActive?: boolean;
  icon?: string;
}
const IconSwitcher = ({isMain, isActive, icon}: IconSwitcherProps) => {
  const {supplierProfile} = useAuth();

  return (
    <>
      {isMain ? (
        <>
          {supplierProfile?.store &&
            supplierProfile?.store.store_status === 'accepted' && (
              <>
                <div className={styles['footer__main-menu']}>
                  <i
                    className={classNames(
                      'pt-1',
                      supplierProfile?.store?.store_type?.icon &&
                        geShopIconConvertor[
                          supplierProfile?.store?.store_type?.icon
                        ],
                    )}
                  />
                </div>
              </>
            )}
          {supplierProfile?.lab &&
            supplierProfile?.lab.lab_status === 'accepted' && (
              <>
                <div className={styles['footer__main-menu']}>
                  <i
                    className={classNames(
                      'pl-1',
                      geShopIconConvertor[
                        supplierProfile?.lab?.store_type?.icon
                      ],
                      styles['footer__icon'],
                    )}
                  />
                </div>
              </>
            )}
          {supplierProfile?.lab?.lab_status !== 'accepted' &&
            supplierProfile?.store?.store_status !== 'accepted' && (
              <div className={styles['footer__main-menu']}>
                <i className="icon-advertising pt-1" />
              </div>
            )}
        </>
      ) : (
        <i
          className={classNames(
            isActive && 'color-primary',
            'm-auto pt-2 ' + icon,
          )}
        />
      )}
    </>
  );
};

export default IconSwitcher;
